// extracted by mini-css-extract-plugin
export default {"containprod":"xT","containprod2":"yT","title":"zT","servings":"AT","recommendation":"BT","image":"CT","flavorswrap":"ET","flavorsgroupwrap":"FT","moredetailsWrap":"GT","infoWrap":"HT","price":"IT","regularPrice":"JT","netPrice":"KT","addtocartcontainer":"LT","error":"MT"};
    if(module.hot) {
      // 1726593107326
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  